import React, { useState } from "react"
import { Box, Container } from "@mui/material"

import { makeStyles } from "makeStyles"

import ItemsCarousel from "react-items-carousel"

import useWindowSize from "@secureo/common/hooks/useWindowSize"

import { BsArrowLeft, BsArrowRight } from "react-icons/bs"

import LazyLoadedImage from "components/LazyLoadedImage"

const useStyles = makeStyles()(() => ({
	arrowButtonLeft: {
		position: "absolute",
		bottom: -50,
		left: "100%",
		padding: 5,
		outline: "none",
		background: "none",
		border: "none",
		cursor: "pointer",
	},
	arrowButtonRight: {
		position: "absolute",
		bottom: -50,
		right: "100%",
		padding: 5,
		outline: "none",
		background: "none",
		border: "none",
		cursor: "pointer",
	},
	image: {
		padding: 0,
		height: 290,
		maxWidth: "100%",
		objectFit: "contain",
		margin: "auto",
	},
	slide: {
		transition: "0.3s",
		textAlign: "center",
		borderRadius: 5,
		zIndex: 1,
		position: "relative",
		height: 290,
		padding: 10,
		background: "#fff",
	},
}))

const Slider = ({ images }: Props) => {
	const { classes } = useStyles()

	const [activeItemIndex, setActiveItemIndex] = useState(0)
	const chevronWidth = 0
	const { innerWidth } = useWindowSize()

	const isDesktop = innerWidth >= 1280

	const slideCount = isDesktop ? 3 : 1

	return (
		<Box my={10}>
			<Container>
				<div style={{ position: "relative" }}>
					<ItemsCarousel
						requestToChangeActive={setActiveItemIndex}
						activeItemIndex={activeItemIndex}
						numberOfCards={slideCount}
						gutter={10}
						leftChevron={
							<button className={classes.arrowButtonLeft}>
								<BsArrowLeft size="1.8rem" color="#fff" />
							</button>
						}
						rightChevron={
							<button className={classes.arrowButtonRight}>
								<BsArrowRight size="1.8rem" color="#fff" />
							</button>
						}
						chevronWidth={chevronWidth}
						infiniteLoop={true}
						slidesToScroll={slideCount}
						showSlither={false}
					>
						{images.map((image) => {
							return (
								<div key={image} className={classes.slide}>
									<LazyLoadedImage
										alt="image"
										title="image"
										src={image}
										className={classes.image}
									/>
								</div>
							)
						})}
					</ItemsCarousel>
				</div>
			</Container>
		</Box>
	)
}

interface Props {
	images: string[]
}

export default Slider
